import * as queryString from 'querystring';

import i18next from 'i18next';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { isForbiddenError, isNotFound } from '../../api/apiError';
import { AuthApi } from '../../api/authApi';
import { setSigninError } from '../../slice/errorSlice';
import { SignIn } from './signIn';

export const Callback: React.FC = () => {
    const history = useHistory();

    const query = queryString.parse(useLocation().search);
    // useLocation().search includes ?
    const token = query['?oauth_token'] as string;
    const verifier = query['oauth_verifier'] as string;

    const dispatch = useDispatch();
    (async () => {
        try {
            await AuthApi.twitterAuthCallback(token, verifier);
            history.push('/');
        } catch (e) {
            if (isNotFound(e)) {
                dispatch(setSigninError(i18next.t('error.userNotFound')));
            } else if (isForbiddenError(e)) {
                dispatch(setSigninError(i18next.t('error.forbidden')));
            } else {
                dispatch(setSigninError(i18next.t('error.login')));
            }
        }
    })();

    return <SignIn />;
};
